import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_VERIFICATION_TYPES_QUERY = gql`
  query pagedVerificationTypes($pager: PagerInputNew, $filters: VerificationTypesFilterInput) {
    pagedVerificationTypes(pager: $pager, filters: $filters) {
      total
      values {
        ...verificationTypeListItem
      }
    }
  }
  ${Fragments.verificationTypeListItem}
`;
